import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useRole } from "./component/contextApi/RoleContext";
import Cookies from "js-cookie";

const ProtectedRoute = ({ type, pageId, children }) => {
  const { setRole, role, permission, setPermission, setUserDetails } = useRole();
  const [isSessionActive, setIsSessionActive] = useState(true); // Track session status
  const [loading, setLoading] = useState(true); //initially set loading as true
  const API_URL = process.env.REACT_APP_BASE_URL;
  console.log("current_role", role);
  console.log("current_Permission", permission);
  const getRecentMenu = permission.find((item) => item.view_permission === "1");
  const navigate = useNavigate();

  useEffect(() => {
    //checking the session status
    const checkSession = async () => {
      try {
        const response = await fetch(`${API_URL}sessionSetting.php`, {
          method: "GET",
        });
        const data = await response.json();
        if (data.status === "error") {
          console.log(data.message); // Handle session expired
          setIsSessionActive(false);
          Cookies.remove("username");
          navigate("/login");
          // Redirect to login page
        } else {
          setRole(data.roleid);
          setPermission(data.permission);
          setUserDetails(data)
          console.log(data.message); // Session is active
          setLoading(false);
          setIsSessionActive(true);
        }
      } catch (err) {
        console.error("error in session", err);
      }
    };
    ////end session status //////////////////
    // if (role) {
    //   setLoading(false);
    // } else {
    checkSession();
    //  }
  }, [pageId]);

  if (loading) {
    return null;
  } else {
    if (type === "common") {
      return children;
    } else if (type === "add") {
      const hasAddPermission =
        Array.isArray(permission) &&
        permission.some(
          (item) => item.category_id === pageId && item.add_permission === "1"
        );
      if (!hasAddPermission) {
        return <Navigate to="/" />;
      }
      return children;
    } else if (type === "edit") {
      const hasEditPermission =
        Array.isArray(permission) &&
        permission.some(
          (item) => item.category_id === pageId && item.edit_permission === "1"
        );

      if (!hasEditPermission) {
        return <Navigate to="/" />;
      }
      return children;
    } else {
      // if (!isSessionActive) {
      //   return null;
      // }
      //  if (role === "1") {
      //  return children;
      // } else {
      // If the role is not defined (e.g., user is not logged in), redirect to login page
      if (role === null) {
        console.log("role showing empty here");
        return <Navigate to="/login" />;
      }

      const hasViewPermission =
        Array.isArray(permission) &&
        permission.some(
          (item) => item.category_id === pageId && item.view_permission === "1"
        );

      if (!hasViewPermission) {
        return <Navigate to="/" />;
      }
      return children;
      //}
    }
  }
};

export default ProtectedRoute;
